module.exports = {
    "Clear search": `Obri\u{161}i pretragu`
};


//# sourceMappingURL=hr-HR.main.js.map
